export const gebruikers = state => state.gebruikers;
export const gebruiker = state => state.gebruiker;
